<template>
  <div class=''>
    <el-upload class="avatar-uploader_1" :action="`${$baseURL}/api/file/uploadImg`" accept=".png,.jpeg,.JPG,.JPEG,.jpg"
      :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
      <img v-if="imgurl" :src="`${$baseURL}/api/file/get?name=${imgurl}`" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: 'uploadlogo',
  props: {
    action: {
      type: String,
      default: ''
    },
    imageUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showFlag: false,
      imgurl: ""
    }
  },
  created() {
    // this.headers = { token: store.state.UserToken }
  },
  mounted() {
    this.imgurl = this.imageUrl;
  },
  watch: {
    imageUrl: {
      handler() {
        this.imgurl = this.imageUrl;
      }
    }
  },
  methods: {
    getUrl() {
      return this.imgurl;
    },
    handleAvatarSuccess(res, file) {
      if (res && res.code == '0') {
        this.imgurl = res.data;
        this.$emit("upSuc", res.data)
      }
    },
    beforeAvatarUpload(file) {
      // this.showFlag = "";
      // const isJPG = file.type === 'image/jpeg';
      // const isLt2M = file.size / 1024 / 1024 < 2;
      //
      // // if (!isJPG) {
      // // this.$message.error('上传头像图片只能是 JPG 格式!');
      // // }
      // if (!isLt2M) {
      //   this.$message.error('上传图片大小不能超过 2MB!');
      // }
      // // return isJPG && isLt2M;
      // return isLt2M;
    }





  }
}
</script>

<style rel="stylesheet/scss" lang="scss" >
.avatar-uploader_1 .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader_1 .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>
